import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@apply4u/services/auth-services/auth.service';
import { Navigation } from '@apply4u/shared/constant/navigation/navigation';
@Component({
  selector: 'app-direct-login',
  templateUrl: './direct-login.component.html',
  styleUrls: ['./direct-login.component.css']
})
export class DirectLoginComponent implements OnInit {

  constructor(private authService:AuthService,
    private routerService: Router,
    // private location: LocationStrategy,
    ) { 
      
    }

  ngOnInit(): void {
    if(this.authService.IsLoggedIn()){
      this.routerService.navigateByUrl(Navigation.DashBoard);
    } else{
      this.authService.SignInRedirect();
    }

  }
  ngOnDestroy(): void {
    // history.pushState(null, "", window.location.href);  
    // this.location.onPopState(() => {
    //   history.pushState(null, "", window.location.href);
    // });
  }
  
}
